








































import {Emit, Prop} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Achat} from '@/models';

import CrudAchatEditReglements from '@/components/Crud/Achat/EditReglements.vue';

@Component({
	components: {
		CrudAchatEditReglements,
	}
})
export default class CrudAchatEditDialogReglement extends Vue {
	@InOut({ type: Achat  , isVModel: true }) private value!: Achat;

	@Emit()
	private onSubmit(achat: Achat) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
